import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const P = (pid) => `${API}/projects/${pid}`;

export const privacy = {
  // Overview + config
  overview: () => axios.get(`${API}/privacy/overview`).then((r) => r.data),
  getConfig: () => axios.get(`${API}/privacy/config`).then((r) => r.data),
  updateConfig: (body) => axios.put(`${API}/privacy/config`, body).then((r) => r.data),
  // Inventory
  listInventory: (params) => axios.get(`${API}/privacy/inventory`, { params }).then((r) => r.data),
  seedInventory: () => axios.post(`${API}/privacy/inventory/seed`).then((r) => r.data),
  createInventory: (body) => axios.post(`${API}/privacy/inventory`, body).then((r) => r.data),
  // Notices
  listNotices: (params) => axios.get(`${API}/privacy/notices`, { params }).then((r) => r.data),
  currentNotice: () => axios.get(`${API}/privacy/notices/current`).then((r) => r.data),
  createNotice: (body) => axios.post(`${API}/privacy/notices`, body).then((r) => r.data),
  transitionNotice: (id, target) => axios.post(`${API}/privacy/notices/${id}/transition`, { target }).then((r) => r.data),
  // Requests
  listRequests: (params) => axios.get(`${API}/privacy/requests`, { params }).then((r) => r.data),
  myRequests: () => axios.get(`${API}/privacy/requests/mine`).then((r) => r.data),
  createRequest: (body) => axios.post(`${API}/privacy/requests`, body).then((r) => r.data),
  verifyIdentity: (id, verified) => axios.post(`${API}/privacy/requests/${id}/verify-identity`, { verified }).then((r) => r.data),
  transitionRequest: (id, body) => axios.post(`${API}/privacy/requests/${id}/transition`, body).then((r) => r.data),
  executeDeletion: (id) => axios.post(`${API}/privacy/requests/${id}/execute-deletion`).then((r) => r.data),
  // Account deletion (self)
  deletionPreview: () => axios.get(`${API}/privacy/account-deletion/preview`).then((r) => r.data),
  requestDeletion: (body) => axios.post(`${API}/privacy/account-deletion`, body || {}).then((r) => r.data),
  // Retention + holds
  listPolicies: () => axios.get(`${API}/privacy/retention/policies`).then((r) => r.data),
  createPolicy: (body) => axios.post(`${API}/privacy/retention/policies`, body).then((r) => r.data),
  dryRun: (id) => axios.get(`${API}/privacy/retention/policies/${id}/dry-run`).then((r) => r.data),
  executePolicy: (id) => axios.post(`${API}/privacy/retention/policies/${id}/execute`).then((r) => r.data),
  listHolds: (params) => axios.get(`${API}/privacy/holds`, { params }).then((r) => r.data),
  createHold: (body) => axios.post(`${API}/privacy/holds`, body).then((r) => r.data),
  releaseHold: (id) => axios.post(`${API}/privacy/holds/${id}/release`).then((r) => r.data),
  // AI governance
  listAiProviders: () => axios.get(`${API}/privacy/ai-providers`).then((r) => r.data),
  seedAiProviders: () => axios.post(`${API}/privacy/ai-providers/seed`).then((r) => r.data),
  toggleAiProvider: (id, enabled) => axios.post(`${API}/privacy/ai-providers/${id}/toggle`, { enabled }).then((r) => r.data),
  aiMinimizationAudit: (context) => axios.post(`${API}/privacy/ai-minimization/audit`, { context }).then((r) => r.data),
  // Security incidents
  listSecIncidents: (params) => axios.get(`${API}/privacy/security-incidents`, { params }).then((r) => r.data),
  createSecIncident: (body) => axios.post(`${API}/privacy/security-incidents`, body).then((r) => r.data),
  getSecIncident: (id) => axios.get(`${API}/privacy/security-incidents/${id}`).then((r) => r.data),
  transitionSecIncident: (id, body) => axios.post(`${API}/privacy/security-incidents/${id}/transition`, body).then((r) => r.data),
  classifySecIncident: (id, body) => axios.post(`${API}/privacy/security-incidents/${id}/classify`, body).then((r) => r.data),
  // Redaction (project-scoped)
  listRedactions: (pid) => axios.get(`${P(pid)}/privacy/redactions`).then((r) => r.data),
  createRedaction: (pid, body) => axios.post(`${P(pid)}/privacy/redactions`, body).then((r) => r.data),
};

export const PRIV_COLOR = {
  RECEIVED: 'bg-blue-100 text-blue-700', IDENTITY_VERIFICATION: 'bg-sky-100 text-sky-700',
  UNDER_REVIEW: 'bg-amber-100 text-amber-700', ACTION_REQUIRED: 'bg-orange-100 text-orange-700',
  FULFILLED: 'bg-green-100 text-green-800', PARTIALLY_FULFILLED: 'bg-teal-100 text-teal-800',
  REJECTED: 'bg-rose-100 text-rose-700', CLOSED: 'bg-slate-200 text-slate-600',
  DRAFT: 'bg-slate-100 text-slate-600', REVIEW: 'bg-amber-100 text-amber-700',
  PUBLISHED: 'bg-green-100 text-green-800', SUPERSEDED: 'bg-slate-200 text-slate-500',
  ARCHIVED: 'bg-slate-200 text-slate-500', ACTIVE: 'bg-green-100 text-green-800',
  RELEASED: 'bg-slate-200 text-slate-600', REPORTED: 'bg-blue-100 text-blue-700',
  TRIAGED: 'bg-sky-100 text-sky-700', INVESTIGATING: 'bg-amber-100 text-amber-700',
  CONTAINED: 'bg-indigo-100 text-indigo-700', ASSESSED: 'bg-cyan-100 text-cyan-800',
  REMEDIATED: 'bg-teal-100 text-teal-800', REPORTABLE: 'bg-rose-100 text-rose-700',
  NOT_REPORTABLE: 'bg-slate-200 text-slate-600', UNCLASSIFIED: 'bg-slate-100 text-slate-600',
};
